export const ESTADOS = {
  EN_LINEA: { label: 'En línea', cls: 'bg-emerald-50 text-emerald-800 border-emerald-200', dot: 'bg-emerald-500' },
  HOY: { label: 'Activo hoy', cls: 'bg-teal-50 text-teal-800 border-teal-200', dot: 'bg-teal-600' },
  SEMANA: { label: 'Esta semana', cls: 'bg-sky-50 text-sky-800 border-sky-200', dot: 'bg-sky-500' },
  INACTIVO: { label: 'Inactivo +7 días', cls: 'bg-amber-50 text-amber-800 border-amber-200', dot: 'bg-amber-500' },
  SIN_REGISTRO: { label: 'Sin registro', cls: 'bg-slate-100 text-slate-600 border-slate-200', dot: 'bg-slate-300' },
};

export const TIPOS = {
  LOGIN: 'Ingreso',
  LOGIN_FALLIDO: 'Ingreso fallido',
  VISTA: 'Pantalla',
  ACCION: 'Acción',
};

export const PERIODOS = [
  { v: 1, l: 'Hoy' }, { v: 7, l: '7 días' }, { v: 30, l: '30 días' }, { v: 90, l: '90 días' }, { v: 365, l: '1 año' },
];

export const fmtDuracion = (seg) => {
  const s = Math.round(seg || 0);
  if (s < 60) return `${s} s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m} min`;
  const h = Math.floor(m / 60);
  return `${h} h ${m % 60 ? `${m % 60} min` : ''}`.trim();
};

const parse = (iso) => (iso ? new Date(iso.length === 10 ? `${iso}T00:00:00` : iso) : null);

export const fmtFechaHora = (iso) => {
  const d = parse(iso);
  if (!d || Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('es-AR', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' });
};

export const haceCuanto = (iso) => {
  const d = parse(iso);
  if (!d || Number.isNaN(d.getTime())) return 'Nunca';
  const min = Math.floor((Date.now() - d.getTime()) / 60000);
  if (min < 1) return 'Recién';
  if (min < 60) return `Hace ${min} min`;
  const h = Math.floor(min / 60);
  if (h < 24) return `Hace ${h} h`;
  const dias = Math.floor(h / 24);
  return dias === 1 ? 'Ayer' : `Hace ${dias} días`;
};

export const dispositivoTxt = (d) => (d ? [d.dispositivo, d.navegador, d.so].filter((x) => x && x !== 'Otro').join(' · ') : '');
